import { trackEvent } from "src/Amplitude";
import { Box, Modal, Typography, Divider, Stack, Button, useTheme } from "@mui/material";
import React, { useEffect, useReducer, useState } from "react";
import api from "src/store/features/api";
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import TargetOrderCancelExecuteSummery from "./TargetOrderCancelExecuteSummery";

interface ExecuteProps {
  open: boolean;
  executeData?: any;
  refetchData: any;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
  handleOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const TargetOrderExecute = (props: ExecuteProps) => {
  const { open, handleClose, executeData, refetchData } = props;

  //----------------------Redux---------------------
  const { data: user } = api.useGetUserDatav2Query();
  const [triggerGam] = api.useCreateGamMutation();
  //----------------------STYLES---------------------
  const theme = useTheme();
  //----------------------HOOKS---------------------
  const [executeCtSuccess, toggleExecuteCtSuccess] = useReducer((isSuccess) => !isSuccess, false);
  const [executeSummery, setExecuteSummery] = useState(true);
  //----------------------CONST---------------------
  const TITLE = "Request to Execute Target At Market";
  const BROKER_NAME = user ? user?.broker.name.split(" ").slice(0, -1) : "";
  const USER_NAME = user?.details.name;
  const BROKER_IMG = user?.broker.imgUrl;
  const BROKER_EMAIL = user?.broker.email;
  const BTN_TITLE = "Send To Broker";
  let customerDate = new Date().toLocaleString();
  /**
   * Handles a user's GAM request by sending the request to the server and refetching data
   *
   */
  const handleGAM = () => {
    const reqBody = {
      requestActionDto: {
        ctId: executeData.ctId,
        datetime: customerDate,
      },
    };
    triggerGam(reqBody);
    trackEvent("Target_Order_Gam");
    toggleExecuteCtSuccess();
    handleClose(false);
  };

  // refetch new data when closing summery
  useEffect(() => {
    if (!executeSummery) {
      refetchData();
    }
  }, [executeSummery]);

  // executeCtSuccess Summery & Broker message on success
  if (executeCtSuccess)
    return (
      <TargetOrderCancelExecuteSummery
        brokerImg={BROKER_IMG}
        brokerName={BROKER_NAME}
        userName={USER_NAME}
        brokerEmail={BROKER_EMAIL}
        open={executeSummery}
        type={"execute"}
        toggle={setExecuteSummery}
      />
    );
  return (
    <Modal
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "583px",
          height: "290px",
          borderRadius: "10px",
          bgcolor: "background.paper",
          boxShadow: 24,
          [theme.breakpoints.down("md")]: {
            width: "90%",
            height: "auto",
          },
        }}>
        <Typography
          sx={{
            fontSize: "23px",
            fontWeight: 600,
            padding: "24px 24px 11.5px 24px",
          }}>
          {TITLE}
        </Typography>
        <Divider sx={{ marginRight: "24px", marginLeft: "24px" }} />
        <Typography
          id="modal-modal-description"
          sx={{
            mt: 2,
            padding: "0px 24px 12px 24px",
            fontSize: "14px",
            fontWeight: 600,
            color: theme.palette.secondary.main,
          }}>
          Please confirm that you want to request an execution for this order at Market price now.
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{
            padding: "0 24px 11.5px 24px",
            fontSize: "14px",
            textDecoration: "underline",
          }}>
          Your target order will be changed into a Market order as below:
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{
            padding: "0 24px 0 24px",
            fontSize: "14px",
          }}>
          {`The current market price of ${
            executeData.currencyTradeCode
          } is approximately ${formatCurrency(
            executeData.currentPrice,
            executeData.currencyConvertCode,
          )}. You are
          requesting to ${executeData.type} ${executeData.tradeUnits} units of ${
            executeData.currencyTradeCode
          } at this market price.`}
        </Typography>
        <Stack
          spacing={1}
          direction="row"
          sx={{
            width: "100%",
            padding: "24px 24px 0 24px",
            [theme.breakpoints.down("md")]: {
              marginBottom: "15px",
            },
          }}>
          <Button
            disableRipple
            onClick={() => {
              handleClose(false);
            }}
            sx={{
              textTransform: "capitalize",
              width: "100%",
              backgroundColor: "#f8f9f9",
              border: 0,
              "&: hover": {
                border: 1,
              },
              [theme.breakpoints.down("md")]: {
                height: "30px",
                fontSize: "14px",
              },
            }}
            variant="outlined">
            Go Back
          </Button>
          <Button
            disableRipple
            onClick={handleGAM}
            sx={{
              width: "100%",
              textTransform: "capitalize",
              boxShadow: "none",
              "&: hover": {
                backgroundColor: "#fedbdb",
                opacity: "10",
                boxShadow: "none",
              },
              backgroundColor: theme.palette.secondary.main,
              [theme.breakpoints.down("md")]: {
                height: "30px",
                fontSize: "14px",
              },
            }}
            variant="contained">
            {BTN_TITLE}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default TargetOrderExecute;
